import React from 'react';

class About extends React.Component {
  constructor () {
    super();
  }

  componentDidMount () {

  }

  componentDidUpdate () {

  }

  /*
  <div className="beta-alert-box" role="alert" >
    <h4 className="title">This app is in development</h4>
    <p>Subscribe to be notified of major changes:</p>
    <div id="mc_embed_signup">
    <form action="//climatelist.us11.list-manage.com/subscribe/post?u=f2cca2534a425dd7b18ec2569&amp;id=f980b4abd7" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate form-inline" target="_blank" noValidate>
      <div id="mc_embed_signup_scroll">
        <div className="mc-field-group form-group">
          <input type="email" placeholder="you@example.com" name="EMAIL" className="required email form-control" id="mce-EMAIL" />
        </div>
        <div style={{position:'absolute',left:'-5000px'}} aria-hidden="true"><input type="text" name="b_f2cca2534a425dd7b18ec2569_f980b4abd7" tabIndex="-1" value="" /></div>
        <input type="submit" value="Keep me posted!" name="subscribe" id="mc-embedded-subscribe" className="button btn btn-primary" />
      </div>
    </form>
    </div>
    <p className="comment">No spam. Emails include a link to unsubscribe.</p>
  </div>
  */

  render() {
    return (
      <div>
        <div className="modal" id="about" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">About ClimateList <span className="badge beta">beta</span></h4>
              </div>
              <div className="modal-body">
                <div className="container-fluid">
                  <p>
                    ClimateList helps travelers visualize where is the best weather through the year.
                  </p>
                  <h4 className="title">Data</h4>
                  <p>
                    Climate metrics are provided by <a href="http://sdwebx.worldbank.org/climateportal/" target="_blank">The World Bank Group</a>.
                  </p>
                  <p>
                    The "Best weather" indicator is based on average temperatures and precipitations. It defines a weather that is not too cold, not too hot, and not too rainy.
                  </p>
                  <p>
                    <img src={require('../images/scale.png')} alt="" className="img-responsive scale" />
                    <img src={require('../images/scale-mobile.png')} alt="" className="img-responsive scale-mobile" />
                  </p>
                  <p>A description of the sources used by ClimateList is <a data-toggle="modal" data-target="#sources" href="#sources" data-dismiss="modal">here</a>.</p>
                  <h4 className="title">Maps</h4>
                  <p>
                    Large countries with multiple climates are divided in climate zones. Metrics for each zone are averages calculated on many sample points.
                  </p>
                  <p>
                    This is still a work in progress and many countries deserving such a division don't have one yet, <a href="https://blog.climatelist.com/im-mapping-the-world-s-climate-here-s-how-82d15b360e8f#.h020kem5j" target="_blank">I'm working on it</a>.
                  </p>
                  <p>
                    <img src={require('../images/map.png')} alt="" className="img-responsive" />
                  </p>
                  <h4 className="title">Maker</h4>
                  <p>This app is built by <a href="http://bastienpetit.com" target="_blank">Bastien Petit</a>. If you find an issue or have suggestions, please contact me on <a href="https://twitter.com/bastienpetit" target="_blank">Twitter</a> or by <a href="mailto:hello@bastienpetit.com">email</a>.</p>
                  <p>Updates are posted on the <a href="https://blog.climatelist.com" target="_blank">blog</a> and <a href="https://twitter.com/climatelist" target="_blank">Twitter</a>. You can read the story behind the creation of ClimateList <a href="https://medium.com/product-people/how-backpacking-inspired-me-to-create-climatelist-6c6cbe25ea2c#.8emwnrbxl" target="_blank">here</a>.
                  </p>
                  <p className="story">
                    <a href="https://medium.com/product-people/how-backpacking-inspired-me-to-create-climatelist-6c6cbe25ea2c#.8emwnrbxl" target="_blank"><img src={require('../images/recent.jpg')} alt="" className="img-responsive" /></a>
                  </p>
                  <p className="legend"><a href="https://medium.com/product-people/how-backpacking-inspired-me-to-create-climatelist-6c6cbe25ea2c#.8emwnrbxl" target="_blank">How backpacking inspired me to create ClimateList</a></p>
                  <h4 className="title">API</h4>
                  <p>If you want to display ClimateList maps on your own website, I would love to discuss it with you, please fill <a data-toggle="modal" data-target="#api" href="#api" data-dismiss="modal">this form</a>.<br /></p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/About.js
 **/